'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var WebApiSharePointConstants = {
    OphalenCollectiviteitKortingenControl: '/_vti_bin/CentraalBeheer.Relatiemanagement.Campagne/Campagne.svc/OphalenCollectiviteitKortingen',
    OphalenWerkgeverControl: '/_vti_bin/CentraalBeheer.Relatiemanagement.Campagne/Campagne.svc/OphalenWerkgever',
    ZoekenWerkgeversControl: '/_vti_bin/CentraalBeheer.Relatiemanagement.Campagne/Campagne.svc/ZoekenWerkgevers',
    OphalenClaimLight: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/CBA.SP.Publiek.Claim.V2/OphalenTrackEnTraceStatusCodes',
    OphalenVragenboom: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/DistributieDirect.SchadeParticulier.Klant.Claim.OphalenVragenboom/',
    OphalenVragenboomStp: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/DistributieDirect.SchadeParticulier.Klant.Claim.OphalenVragenboom/',
    IndienenVragenboom: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/DistributieDirect.SchadeParticulier.Klant.Claim.IndienenVragenboom/',
    VerzekeringsKiezer: '/json/verzekeringskiezer.json.js',
    OphalenWachttijden: '/_vti_bin/Achmea.SharePoint.WebApiProxy/Proxy.svc/Achmea.KCC.Communication.OphalenWachttijden'
};

exports.default = WebApiSharePointConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/webapi/web-api-sharepoint.constants.js
// module id = 837
// module chunks = 0